import { default as emerging } from './buckets/emerging';
import { default as future } from './buckets/future';
import { default as lite } from './buckets/lite';
import { default as established } from './buckets/established';
import { default as scaling } from './buckets/scaling';

export default {
  ...emerging,
  ...future,
  ...lite,
  ...established,
  ...scaling,
};
